var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoSimulations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 82,
    viewBox: "0 0 119 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-723 -395)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(723 395)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 82,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 117,
    height: 80,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(736 404)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 34,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 92,
    height: 32,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 25,
    transform: "translate(752 412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    transform: "translate(769 419)",
    fill: "#de4f25"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 29,
    transform: "translate(784 409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 39.036,
    transform: "translate(734.054 450.016)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 39.036,
    transform: "translate(786.562 450.016)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 39.036,
    transform: "translate(734.054 456.925)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 39.036,
    transform: "translate(786.562 456.925)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 39.036,
    transform: "translate(734.054 465.907)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x2: 39.036,
    transform: "translate(786.562 465.907)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoSimulations);
export default __webpack_public_path__ + "static/media/picto-simulations.dbc7be0ca944c02ff8c90998fe31f93b.svg";
export { ForwardRef as ReactComponent };